import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {Injectable} from '@angular/core';
import {BorrowedInfo} from '../model/borrowed-info.model';

@Injectable()
export class BorrowedInfoService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async create(borrowedInfo: BorrowedInfo): Promise<BorrowedInfo> {
        const url = this.configService.loanApplicationServiceUrl() + '/existing-debt';
        return await this.httpClient.post<BorrowedInfo>(url, borrowedInfo).toPromise();
    }

    public async getByLoanApplicationId(loanApplicationId: String): Promise<BorrowedInfo> {
        const url = this.configService.loanApplicationServiceUrl() + `/existing-debt?loanApplicationId=${loanApplicationId}`;
        return await this.httpClient.get<BorrowedInfo>(url).toPromise();
    }

    public async update(borrowedInfo: BorrowedInfo): Promise<BorrowedInfo> {
        const url = this.configService.loanApplicationServiceUrl() + `/existing-debt/${borrowedInfo.id}`;
        return await this.httpClient.put<BorrowedInfo>(url, borrowedInfo).toPromise();
    }

    public async delete(borrowedInfoId: string): Promise<BorrowedInfo> {
        const url = this.configService.loanApplicationServiceUrl() + `/existing-debt/${borrowedInfoId}`;
        return await this.httpClient.put<BorrowedInfo>(url, borrowedInfoId).toPromise();
    }
}
